import { create } from 'zustand';
import axios from '../utils/axios';
import { ENDPOINTS } from '../config/api';

const useProductStore = create((set) => ({
  products: [],
  product: null,
  featuredProducts: [],
  newArrivals: [],
  onSaleProducts: [],
  loading: false,
  error: null,
  pagination: {
    page: 1,
    total: 0,
    count: 0,
  },

  // Get all products
  getProducts: async (params = {}) => {
    set({ loading: true, error: null });
    try {
      const response = await axios.get(ENDPOINTS.PRODUCTS.BASE, { params });
      const { data } = response;
      set({
        products: data.data || [],
        pagination: {
          page: params.page || 1,
          total: data.total || 0,
          count: data.count || 0,
        },
        loading: false,
      });
      return response;
    } catch (error) {
      set({ error: error.message, loading: false });
      throw error;
    }
  },

  // Get single product
  getProduct: async (id) => {
    set({ loading: true, error: null });
    try {
      const response = await axios.get(ENDPOINTS.PRODUCTS.BY_ID(id));
      set({ product: response.data.data, loading: false });
      return response;
    } catch (error) {
      set({ error: error.message, loading: false });
      throw error;
    }
  },

  // Get product by slug
  getProductBySlug: async (slug) => {
    set({ loading: true, error: null });
    try {
      const response = await axios.get(ENDPOINTS.PRODUCTS.BY_SLUG(slug));
      set({ product: response.data.data, loading: false });
      return response;
    } catch (error) {
      set({ error: error.message, loading: false });
      throw error;
    }
  },

  // Get featured products
  getFeaturedProducts: async () => {
    set({ loading: true, error: null });
    try {
      const response = await axios.get(ENDPOINTS.PRODUCTS.FEATURED);
      set({ featuredProducts: response.data.data || [], loading: false });
      return response;
    } catch (error) {
      set({ error: error.message, loading: false });
      throw error;
    }
  },

  // Get new arrivals
  getNewArrivals: async () => {
    set({ loading: true, error: null });
    try {
      const response = await axios.get(ENDPOINTS.PRODUCTS.NEW_ARRIVALS);
      set({ newArrivals: response.data.data || [], loading: false });
      return response;
    } catch (error) {
      set({ error: error.message, loading: false });
      throw error;
    }
  },

  // Get on sale products
  getOnSaleProducts: async () => {
    set({ loading: true, error: null });
    try {
      const response = await axios.get(ENDPOINTS.PRODUCTS.ON_SALE);
      set({ onSaleProducts: response.data.data || [], loading: false });
      return response;
    } catch (error) {
      set({ error: error.message, loading: false });
      throw error;
    }
  },

  // Create product (Admin)
  createProduct: async (productData) => {
    set({ loading: true, error: null });
    try {
      const response = await axios.post(ENDPOINTS.PRODUCTS.BASE, productData);
      set({ loading: false });
      return response;
    } catch (error) {
      set({ error: error.message, loading: false });
      throw error;
    }
  },

  // Update product (Admin)
  updateProduct: async (id, productData) => {
    set({ loading: true, error: null });
    try {
      const response = await axios.put(ENDPOINTS.PRODUCTS.BY_ID(id), productData);
      set({ loading: false });
      return response;
    } catch (error) {
      set({ error: error.message, loading: false });
      throw error;
    }
  },

  // Delete product (Admin)
  deleteProduct: async (id) => {
    set({ loading: true, error: null });
    try {
      const response = await axios.delete(ENDPOINTS.PRODUCTS.BY_ID(id));
      set({ loading: false });
      return response;
    } catch (error) {
      set({ error: error.message, loading: false });
      throw error;
    }
  },
}));

export default useProductStore;

